import script from "./AppHeaderSettingsExcludes.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeaderSettingsExcludes.vue?vue&type=script&setup=true&lang=js"

import "./AppHeaderSettingsExcludes.vue?vue&type=style&index=0&id=10ef3e71&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10ef3e71"]])

export default __exports__